module.exports = __webpack_public_path__ + "media/images/background/subheader-dark-7ddce2fc2d02c95681e1fe58503f9d1a.jpg";